import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";
import AuthScreen from "@/components/AuthScreen";
import AppShell from "@/components/AppShell";
import Dashboard from "@/pages/Dashboard";
import Integrations from "@/pages/Integrations";
import Billing from "@/pages/Billing";
import Settings from "@/pages/Settings";
import Workspace from "@/pages/Workspace";

function Gate() {
  const { user, booting } = useAuth();
  if (booting) return <div className="h-screen grid place-items-center text-gray-400"><Loader2 className="w-6 h-6 animate-spin" /></div>;
  if (!user) return <AuthScreen />;
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/projects" element={<Dashboard />} />
        <Route path="/integrations" element={<Integrations />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/workspace/:projectId" element={<Workspace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Gate />
        <Toaster position="top-center" />
      </AuthProvider>
    </BrowserRouter>
  );
}
